import React, { Component } from 'react'
import Text from '../../atoms/Text/Text'

export default class ViewMore extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }

    this.toggleOpen = this.toggleOpen.bind(this)
  }

  toggleOpen() {
    this.setState({ open: true })
  }
  render() {
    const { count, wrapper } = this.props
    const Wrapper = wrapper
    return (
      <div>
        <Wrapper>
          {this.props.render.slice(0, count)}
          {this.state.open && this.props.render.slice(count)}
        </Wrapper>
        <div style={{ textAlign: 'center' }}>
          {this.props.render.length > count && !this.state.open && (
            <Text
              style={{ display: 'inline', cursor: 'pointer' }}
              align="center"
              bold
              large
              underline
              onClick={this.toggleOpen}
            >
              {this.props.label}
            </Text>
          )}
        </div>
      </div>
    )
  }
}
